<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p14"><span><a href="#/Contents#rp14">CANNED VEGETABLE STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>A quick and easy solution for stock when you haven’t the time or inclination to start from scratch.</i></span></p>
<p class="make"><span>Makes about 1½ quarts</span></p>
<p class="hang"><span>1 each: coarsely chopped medium onion, tomato, carrot, rib celery</span></p>
<p class="hang"><span>4 teaspoons minced garlic</span></p>
<p class="hang"><span>1 teaspoon olive oil</span></p>
<p class="hang"><span>2 cans (14½ ounces each) reduced-sodium vegetable broth</span></p>
<p class="hang"><span>2 cups water</span></p>
<p class="hang"><span>1 cup dry white wine or water</span></p>
<p class="hang"><span>4 sprigs parsley</span></p>
<p class="hang"><span>2 bay leaves</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><a id="page_11"></a><b>1.</b> Sauté onion, tomato, carrot, celery, and garlic in oil in Dutch oven 5 minutes; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 30 minutes. Strain, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 62</span></p>
<p class="per1"><span>% calories from fat: 11</span></p>
<p class="per1"><span>Protein (g): 0.8</span></p>
<p class="per1"><span>Carbohydrate (g): 6.7</span></p>
<p class="per1"><span>Fat (g): 0.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 55</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0114.vue?04e3eafb